import { useEffect, useState } from 'react';
import { applyServerInventory, subscribe } from './plotStore';

/**
 * Re-render the caller whenever the plot inventory changes — including changes
 * made by another browser tab. Components read through the store's selectors
 * after this fires, so there is one source of truth and no local mirror to
 * fall out of sync.
 */
export const useInventory = () => {
  const [, setVersion] = useState(0);
  useEffect(() => subscribe(() => setVersion((v) => v + 1)), []);
};

/**
 * Pull the real sold/pending ledger from the backend once on mount and overlay
 * it on the map. In the demo (or plain `npm start`, where the Function isn't
 * running) the request fails quietly and the local demo inventory is used.
 */
export const useServerInventory = () => {
  useEffect(() => {
    let cancelled = false;
    fetch('/api/availability')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data) applyServerInventory(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
};

/** Re-render once a second — for the hold countdown. Idle when `active` is false. */
export const useTick = (active) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!active) return undefined;
    const id = window.setInterval(() => setTick((t) => t + 1), 1000);
    return () => window.clearInterval(id);
  }, [active]);
};

/** "4:32" — a hold countdown. */
export const formatCountdown = (msRemaining) => {
  const total = Math.max(0, Math.ceil(msRemaining / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};
